import { inject, Injectable } from '@angular/core';

import {
  OutputEmitGuard,
  PerformChecksConfig,
} from '../../canvas-elements/io-data/models/output-handler.models';
import { FormGroupOutputSynchronizer } from '../../canvas-elements/io-data/outputs/form-group-output-synchronizer';

@Injectable({ providedIn: 'root' })
export class FormGroupOutputEmitGuard implements OutputEmitGuard {
  private readonly formGroupOutputGuard = inject(FormGroupOutputSynchronizer);

  preEmit({
    event,
    element,
    validationHandler,
    elements,
    wizardMeta,
  }: PerformChecksConfig): boolean {
    return this.formGroupOutputGuard.checkFormGroupLikeTargets(
      event,
      element,
      validationHandler,
      elements,
      wizardMeta,
    );
  }
}
